import CategoryCards from './CategoryCards';

export { CategoryCards };


// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/AdminComponents/CategoryCards/index.js